import React from 'react';
import { translate } from 'react-i18next';
import { func, number } from 'prop-types';

import { Button, Modal, SimpleDialog } from '@snapask/common-components';

import Gray from '@snapask/common-components/styles/buttonTheme/gray.scss';
import whiteDialogTheme from '@snapask/common-components/styles/simpleDialogTheme/white.scss';

import modalTheme from './modalTheme.scss';

function CompletedProfileDialog({
  t,
  handleConfirm,
  handleAskQuestion,
  quota,
}) {
  return (
    <Modal onClose={() => {}} theme={modalTheme}>
      <SimpleDialog
        title={t('account.completeRequiredFields.title', { quota })}
        description={t('account.completeRequiredFields.desc')}
        bgImage={t('account.completeRequiredFields.image')}
        theme={whiteDialogTheme}
      >
        <Button
          theme={Gray}
          onClick={handleConfirm}
          text={t('account.completeRequiredFields.btn.leftText')}
          ghost
        />
        <Button
          onClick={handleAskQuestion}
          text={t('account.completeRequiredFields.btn.rightText')}
        />
      </SimpleDialog>
    </Modal>
  );
}

CompletedProfileDialog.propTypes = {
  handleAskQuestion: func.isRequired,
  handleConfirm: func.isRequired,
  quota: number.isRequired,
  t: func.isRequired,
};

export default translate(['account'])(CompletedProfileDialog);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/CompletedProfileDialog/CompletedProfileDialog.jsx